import { render, staticRenderFns } from "./RecomendationStep.vue?vue&type=template&id=378100f6"
import script from "./RecomendationStep.vue?vue&type=script&lang=js"
export * from "./RecomendationStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports